import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { QRCodeSVG } from 'qrcode.react';
import QRCode from 'qrcode';
import { jsPDF } from 'jspdf';
import { Copy, MessageCircle, Printer, Loader2 } from 'lucide-react';
import { partnerPortalAPI } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const printPoster = async (url, invite) => {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  const qr = await QRCode.toDataURL(url, { margin: 1, width: 800 });
  doc.setFillColor(245, 158, 11); doc.rect(0, 0, 210, 48, 'F');
  doc.setTextColor(255, 255, 255); doc.setFont('helvetica', 'bold'); doc.setFontSize(30);
  doc.text('Procurando emprego?', 105, 24, { align: 'center' });
  doc.setFontSize(15); doc.setFont('helvetica', 'normal');
  doc.text('Cadastre seu currículo grátis no app G2eGente', 105, 37, { align: 'center' });
  doc.addImage(qr, 'PNG', 45, 62, 120, 120);
  doc.setTextColor(15, 23, 42); doc.setFont('helvetica', 'bold'); doc.setFontSize(18);
  doc.text('Aponte a câmera do celular para o QR code', 105, 198, { align: 'center' });
  doc.setFont('helvetica', 'normal'); doc.setFontSize(12); doc.setTextColor(71, 85, 105);
  doc.text(['1. Abra a câmera e leia o código', '2. Faça seu cadastro com CPF e celular', '3. Complete o perfil e anexe seu currículo'], 105, 212, { align: 'center', lineHeightFactor: 1.6 });
  doc.setFont('helvetica', 'bold'); doc.setFontSize(14); doc.setTextColor(180, 83, 9);
  doc.text(invite.nome, 105, 252, { align: 'center', maxWidth: 180 });
  doc.setFont('helvetica', 'normal'); doc.setFontSize(11); doc.setTextColor(100, 116, 139);
  doc.text(`${invite.municipio || ''}${invite.estado ? `/${invite.estado}` : ''}`, 105, 260, { align: 'center' });
  doc.text(url, 105, 280, { align: 'center' });
  doc.setFont('helvetica', 'bold'); doc.setTextColor(14, 116, 144);
  doc.text('www.G2eGente.com.br', 105, 288, { align: 'center' });
  doc.save('Cartaz_Cadastro_G2eGente.pdf');
};

export const PartnerInviteTab = () => {
  const [invite, setInvite] = useState(null);
  useEffect(() => { partnerPortalAPI.invite().then((r) => setInvite(r.data)).catch(() => toast.error('Erro ao gerar convite')); }, []);
  if (!invite) return <Loader2 className="w-6 h-6 animate-spin text-amber-500 mx-auto" />;

  const url = `${window.location.origin}/m/register?entidade=${invite.code}`;
  const msg = `Cadastre seu currículo grátis no app G2eGente pela ${invite.nome}: ${url}`;
  const copy = () => navigator.clipboard.writeText(url).then(() => toast.success('Link copiado'));

  return (
    <Card data-testid="partner-invite-tab">
      <CardHeader>
        <CardTitle>Convite da Entidade</CardTitle>
        <CardDescription>Quem se cadastrar por este link ou QR code já fica vinculado à sua entidade.</CardDescription>
      </CardHeader>
      <CardContent className="grid md:grid-cols-[auto,1fr] gap-6 items-start">
        <div className="p-3 bg-white border rounded-xl" data-testid="partner-invite-qr"><QRCodeSVG value={url} size={180} /></div>
        <div className="space-y-3">
          <div className="flex gap-2">
            <Input readOnly value={url} data-testid="partner-invite-link" />
            <Button variant="outline" onClick={copy} data-testid="partner-invite-copy"><Copy className="w-4 h-4" /></Button>
          </div>
          <div className="flex flex-wrap gap-2">
            <Button asChild className="bg-green-600 hover:bg-green-700" data-testid="partner-invite-whatsapp">
              <a href={`https://wa.me/?text=${encodeURIComponent(msg)}`} target="_blank" rel="noreferrer"><MessageCircle className="w-4 h-4 mr-2" />Enviar por WhatsApp</a>
            </Button>
            <Button variant="outline" onClick={() => printPoster(url, invite)} data-testid="partner-invite-poster"><Printer className="w-4 h-4 mr-2" />Baixar cartaz A4</Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
